import { createContext, useContext, useState, useCallback } from 'react';
import type { ReactNode } from 'react';

interface PageFooterContextValue {
  footerNode: ReactNode;
  setFooterNode: (node: ReactNode) => void;
}

const PageFooterContext = createContext<PageFooterContextValue>({
  footerNode: null,
  setFooterNode: () => {},
});

export function PageFooterProvider({ children }: { children: ReactNode }) {
  const [footerNode, setFooterNodeState] = useState<ReactNode>(null);
  const setFooterNode = useCallback((node: ReactNode) => setFooterNodeState(node), []);
  return (
    <PageFooterContext.Provider value={{ footerNode, setFooterNode }}>
      {children}
    </PageFooterContext.Provider>
  );
}

export function usePageFooter() {
  return useContext(PageFooterContext);
}
